var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TranslationDisplay',{staticClass:"lift-description",class:{'lift-description--no-bottom-space': _vm.noBottomSpace},attrs:{"translation":_vm.lift.excerpt,"html":""}})}
var staticRenderFns = []

export { render, staticRenderFns }